import { render, staticRenderFns } from "./companyMenu.vue?vue&type=template&id=0c870a9d&scoped=true"
import script from "./companyMenu.vue?vue&type=script&lang=js"
export * from "./companyMenu.vue?vue&type=script&lang=js"
import style0 from "./companyMenu.vue?vue&type=style&index=0&id=0c870a9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c870a9d",
  null
  
)

export default component.exports